function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "html5-01"
}, React.createElement("path", {
  d: "M178,0.8 L355.5,0.8 L323.6,361.9 L178,402.2 L32.4,361.9 L0.5,0.8 L178,0.8 Z M119.5,165.7 L115.6,120.5 L178,120.5 L178,76.1 L66.8,76.1 L79.1,210.1 L178,210.1 L178,165.7 L119.5,165.7 Z M128.7,267.2 L125.3,232 L80.7,232 L87.2,301.6 L178,326.9 L178,281 L128.7,267.2 Z M280.4,165.7 L178,165.7 L178,210.1 L232.5,210.1 L227.2,267.4 L178,281 L178,326.9 L268.4,301.6 L280.4,165.7 Z M284.8,120.5 L288.1,76.1 L178,76.1 L178,120.5 L284.8,120.5 Z",
  id: "Combined-Shape",
  fill: "url(#tech-gradient) #000",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Group",
  transform: "translate(66.000000, 76.000000)"
}), React.createElement("g", {
  id: "Group",
  transform: "translate(66.000000, 76.000000)"
})));

function SvgHtml501(props) {
  return React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "356px",
    height: "403px",
    viewBox: "0 0 356 403"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1pZFlNaWQgbWVldCIgd2lkdGg9IjM1NnB4IiBoZWlnaHQ9IjQwM3B4IiB2aWV3Qm94PSIwIDAgMzU2IDQwMyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJodG1sNS0wMSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNzgsMC44IEwzNTUuNSwwLjggTDMyMy42LDM2MS45IEwxNzgsNDAyLjIgTDMyLjQsMzYxLjkgTDAuNSwwLjggTDE3OCwwLjggWiBNMTE5LjUsMTY1LjcgTDExNS42LDEyMC41IEwxNzgsMTIwLjUgTDE3OCw3Ni4xIEw2Ni44LDc2LjEgTDc5LjEsMjEwLjEgTDE3OCwyMTAuMSBMMTc4LDE2NS43IEwxMTkuNSwxNjUuNyBaIE0xMjguNywyNjcuMiBMMTI1LjMsMjMyIEw4MC43LDIzMiBMODcuMiwzMDEuNiBMMTc4LDMyNi45IEwxNzgsMjgxIEwxMjguNywyNjcuMiBaIE0yODAuNCwxNjUuNyBMMTc4LDE2NS43IEwxNzgsMjEwLjEgTDIzMi41LDIxMC4xIEwyMjcuMiwyNjcuNCBMMTc4LDI4MSBMMTc4LDMyNi45IEwyNjguNCwzMDEuNiBMMjgwLjQsMTY1LjcgWiBNMjg0LjgsMTIwLjUgTDI4OC4xLDc2LjEgTDE3OCw3Ni4xIEwxNzgsMTIwLjUgTDI4NC44LDEyMC41IFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0idXJsKCN0ZWNoLWdyYWRpZW50KSAjMDAwIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2Ni4wMDAwMDAsIDc2LjAwMDAwMCkiPjwvZz4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2Ni4wMDAwMDAsIDc2LjAwMDAwMCkiPjwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgHtml501 as ReactComponent };